import { Radio as BaseRadio } from 'antd';

// FIXME: we should create our own Radio component to encapsulate ant-design and make it easier to replace later.
//  But forms is a too complex topic and I'm not ready to predict what should be allowed to use from ant-design and what should not.
//   So, at least for a while, it is ok to use the whole API. Later with getting experience (use cases), we will be able to make a decision.
const Radio = BaseRadio;
export { Radio };
export default Radio;
